// eslint-disable
import { ShopLoginPlugin, AdminLoginPlugin } from '@holdingblachere/vue-common-ui';

const routes = [
  ...AdminLoginPlugin.routes,
  ...ShopLoginPlugin.routes,
  // Full Page Layout
  {
    path: '/u',
    component: () => import('@/layouts/FullPage/FullPage'),
    children: [
      {
        path: '/auth',
        component: () => import('@/views/pages/Auth/Auth.vue'),
      },
      {
        path: '/welcoming',
        name: 'Welcoming',
        component: () => import('@/views/pages/Welcoming.vue'),
        meta: {
          guestOnly: true,
        },
      },
      {
        path: '/connexion-ad',
        name: 'ADAuth',
        component: () => import('@/views/pages/ADAuth/ADAuth.vue'),
        meta: {
          guestOnly: true,
        },
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/pages/Login'),
        meta: {
          shopAuth: true,
        },
      },
      {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/views/pages/Logout'),
        meta: { auth: true },
      },
      {
        path: '/management-shop-auth',
        name: 'MgmtShopAuth',
        component: () => import('@/views/pages/MgmtShopAuth'),
        props: (route) => ({ email: route.query.email }),
        meta: { guestOnly: true },
      },
    ],
  },
  {
    path: '/app',
    name: 'Dashboard',
    component: () => import('@/layouts/AppLayout/AppLayout'),
    redirect: { name: 'HelloWorld' },
    children: [
      {
        path: '/home',
        name: 'HelloWorld',
        component: () => import('@/views/pages/HelloWorldPage'),
        meta: { auth: true },
      },
      {
        path: '/cart',
        name: 'Cart',
        component: () => import('@/views/pages/Cart/Cart'),
        meta: { auth: true },
      },
      {
        path: '/history',
        name: 'History',
        component: () => import('@/views/pages/History/History'),
        meta: { auth: true },
      },
    ],
  },
  {
    path: '/*',
    redirect: { name: 'Dashboard' },
  },
];

export default routes;
